import React from "react";
import { Menu } from "./menu";

export function UnifiedMenuView({ items, expanded, onCollapse, onExpand }) {
    const classes = "unifiedMenu" + (expanded ? " expanded" : "");

    return (
        <nav
            data-testid="unified-menu"
            className={classes}
            onMouseEnter={onExpand}
            onMouseLeave={onCollapse}
        >
            <Menu items={items} />
        </nav>
    );
}
